export interface ChangelogEntry {
    version: string;
    date: string;
    entries: {
        en: string[];
        de: string[];
    };
}

// Neueste zuerst. CalVer vYY.MM.DD[.n] - lexikografisch sortierbar, daher reicht ein simpler
// String-Vergleich der Versions-IDs fuer den "neuer als zuletzt gesehen"-Check (siehe
// ChangelogDialog.tsx). Jeder nutzersichtbare Release bekommt hier seinen Eintrag als Commit
// (Pflegeprozess siehe TASKS.md, "Changelog-/News-Dialog nach dem Login").
export const CHANGELOG: ChangelogEntry[] = [
    {
        version: 'v26.09.08',
        date: '2026-09-08',
        entries: {
            en: ['Basic plan: new price €12 / month or €120 / year (incl. VAT)'],
            de: ['Basic-Abo: neuer Preis 12 € / Monat bzw. 120 € / Jahr (inkl. USt.)'],
        },
    },
];
